import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';

/**
 * ISO 27001 A.12.4.1 Event Logging
 * Service for creating tamper-evident audit logs for critical system actions.
 */

export interface AuditLogEntry {
    actorId: string; // UID of the admin performing the action
    actorEmail: string;
    action: 'APPROVE_USER' | 'REVOKE_USER' | 'PROMOTE_USER' | 'DELETE_USER' | 'LOGIN' | 'LOGIN_FAILED' | 'ACCESS_DENIED' | 'UPDATE_USER_PERMISSIONS' | 'SUSPEND_USER';
    targetUserId?: string; // UID of the user being affected
    targetUserEmail?: string;
    details: string; // Human-readable description
    clientId?: string; // Multi-tenant isolation
    ipAddress?: string; // Reserved for future use (requires backend headers)
}

/**
 * Writes an immutable audit log entry to Firestore.
 * This function should be called for all Identity & Access Management (IAM) changes.
 */
export const logAuditAction = async (entry: AuditLogEntry) => {
    const db = getFirestore();
    try {
        await addDoc(collection(db, 'auditLogs'), {
            ...entry,
            timestamp: serverTimestamp(),
            userAgent: navigator.userAgent
        });
        console.info(`[AUDIT] ${entry.action}: ${entry.details}`);
    } catch (error) {
        console.error('CRITICAL: Failed to write audit log. This is a compliance failure.', error);
        // Note: In high-security modes, we might want to throw here to prevent the action from succeeding if it can't be logged.
    }
};
